import React from 'react'
import { Formik, Form } from 'formik'
import { Button, Container, Grid, Link, TextField, BottomNavigationAction } from '@material-ui/core';
import { getErrorProps } from '../utils'
import { useStore } from '../Store'
import { useToaster } from './Toaster';
import useOnlineStatus from '../hooks/useOnlineStatus';
import Logo from './Logo'
import Header from './Header';
import ActionBar from './ActionBar';
import AppRegistrationIcon from '@material-ui/icons/HowToReg';

const Login = ({ history }) => {
    const isOnline = useOnlineStatus()
    const { showError } = useToaster()
    const { login } = useStore()

    const initialValues = {
        username: "",
        password: ""
    }

    const validate = (values) => {
        const errors = {}
        if (!values.username) {
            errors.username = 'vul uw gebruikersnaam in';
        }
        if (!values.password) {
            errors.password = 'vul uw wachtwoord in';
        }
        return errors
    }

    const submit = async (formik) => {
        const values = formik.values
        formik.validateForm(values)
        if (!formik.isValid) {
            showError('Een of meerdere gegevens ontbreken')
            return
        }
        if (!isOnline) {
            showError('Geen verbinding met de server')
            return
        }

        try {
            await login(values.username, values.password)
            history.push("/")
        } catch (error) {
            showError(error)
        }
    }

    return (
        <>
        <Header title="Inloggen" />
            <Formik
                initialValues={initialValues}
                validate={validate}
            >
                {(formik) => (
                    <Container>
                        <Grid
                            container
                            justify="center"
                            alignItems="center">
                            <Form>
                                <Grid container>
                                    <Grid item xs={12} style={{ textAlign: 'center' }} >
                                        <h1>Inloggen</h1>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="gebruikersnaam" variant="standard" fullWidth
                                            {...formik.getFieldProps("username")}
                                            {...getErrorProps(formik, "username")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="wachtwoord" variant="standard" type="password" fullWidth
                                            autoComplete="off"
                                            {...formik.getFieldProps("password")}
                                            {...getErrorProps(formik, "password")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button disabled={!formik.isValid} variant="contained" onClick={() => submit(formik)} color="primary" fullWidth>Inloggen</Button>
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                                        <Logo />
                                    </Grid>
                                </Grid>
                            </Form>
                        </Grid>
                    </Container>
                )}
            </Formik>
            {parseInt(process.env.REACT_APP_PROJECTID) === 61 &&
          <ActionBar>
            <BottomNavigationAction label='Registeren' component={Link} onClick={() => history.push('/register')} style={{ color: '#00547d' }} icon={<AppRegistrationIcon />} />
          </ActionBar>}

            </>

    )
}

export default Login
